import { useTranslation } from 'react-i18next';

import { Alert } from 'components/Display/Alert';
import { Checkbox } from 'components/Form/Checkbox/Checkbox';

export const PaymentReconciliationBanner = ({
  onCheckboxClick,
  checked,
}: {
  onCheckboxClick: () => void;
  checked: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Alert
      withoutIcon
      severity="warning"
      fullWidth
      actions={{
        alignment: 'right',
        primary: {
          as: 'div',
          analyticsId: 'payment-reconciliation-details-view-pending-lines',
          children: <Checkbox label={t('paymentReconciliation:detailPage.banner.checkboxLabel')} checked={checked} />,
          onClick: (e) => {
            // If clicking on the label stop the call, since the click on the button will also be called
            // Not checking directly by label node, since that means we know how the component is rendered
            if (!(e.target instanceof HTMLInputElement) && e.target !== e.currentTarget) {
              return;
            }
            onCheckboxClick();
          },
        },
      }}
    >
      {t('paymentReconciliation:detailPage.banner.text')}
    </Alert>
  );
};
